import { useFeeds } from '@/core/contexts/feeds.context';
import { useEffect } from 'react';

const useFeedsIntervalGuard = () => {
  const { enableFeeds, disableFeeds } = useFeeds();

  useEffect(() => {
    disableFeeds();
    return () => enableFeeds();
  });
};

export default useFeedsIntervalGuard;
